@if (showErrors && errors?.length) {
  <div class="error-message-wrapper">
    <span class="error-message">
      {{errors[0].translate ? (errors[0].key | translate:errors[0]) : errors[0].params}}
    </span>
  </div>
}
